var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBgRectangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 170,
    height: 63,
    viewBox: "0 0 170 63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#BEBF55"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100 1247L270 1247 251.621 1278.5 270 1310 100 1310z",
    transform: "translate(-100 -1247)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgRectangle);
export default __webpack_public_path__ + "static/media/bg-rectangle.937abd4b468364498ce81b2a9e7fe464.svg";
export { ForwardRef as ReactComponent };